import '../../../../styles/pages/warehouse/_return/index.scss';
import { useLocation, useParams } from 'react-router-dom';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import ReturnOrderPage from './ReturnOrderPage';
import ReturnImportPage from './ReturnImportPage';
import ReturnStockPage from './ReturnStockPage';
import { useActions } from '@root/core/hooks/useActions';
import { useEffect, useState } from 'react';
import {
  CommentGroup,
  CommentList,
  CommentTabs,
  CommentType,
  CreateComment
} from '@core/components/CommentTabs/interface';
import commentService from '@core/components/CommentTabs/commentService';
import CommentTabsComponent from '@core/components/CommentTabs';
import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import { ReturnDisposalDetailState } from '@root/state/reducers/return_disposal/returnDisposalReducer';
import { ReturnStatus } from '@root/modules/Sellers/Shipping/enum';
interface ParamType {
  id: string;
}
function ReturnPageDetail() {
  const location = useLocation<any>();
  const Breadcrumb = [
    {
      tittle: 'Retransfer/Disposal ',
      url: '/admin/return'
    },
    {
      tittle: 'Detailed Retransfer / Disposal  ',
      url: ''
    }
  ];

  // handle api detail
  const { id } = useParams<ParamType>();

  const { handleReturnDisposalDetail } = useActions();
  const { detailData } = useTypedSelector<ReturnDisposalDetailState>(
    (state) => state.returnDisposalDetailReducer
  );

  const [commentList, setCommentList] = useState<CommentList>();
  const [tabs, setTabs] = useState<CommentTabs[]>([]);
  const [commentAllId, setCommentAllId] = useState(0);
  const [canEdit, setCanEdit] = useState(false);

  useEffect(() => {
    if (detailData?.data) {
      switch (detailData?.data?.status) {
        case ReturnStatus.Request:
          setTabs([
            {
              title: 'Comment',
              type: CommentType.COMMON,
              description: 'Comment from Warehouse :'
            },
            {
              title: 'Request modify',
              description: 'Reasons for modification from Warehouse :',
              type: CommentType.REQUEST_MODIFY,
              options: []
            }
          ]);
          break;
        case ReturnStatus.Inprogress:
        case ReturnStatus.Completed:
          setTabs([]);
          break;
      }
    }
  }, [detailData]);

  const onSendComment = async (body: CreateComment, id?: number) => {
    if (id) {
      await commentService.updateComment(id, body);
    } else {
      await commentService.sendComment(body);
    }
    await getCommentList();
  };

  const getCommentList = async (showLoading?: Boolean) => {
    if (showLoading) {
    }
    const comments = await commentService.getComments({
      group: CommentGroup.RETURN_DETAIL,
      itemId: parseInt(id)
    });
    setCommentList(comments);
    if (showLoading) {
    }
  };

  useEffect(() => {
    getCommentList();
  }, []);

  useEffect(() => {
    handleReturnDisposalDetail(id);
  }, []);

  useEffect(() => {
    getCommentList();
  }, [canEdit]);
  return (
    <>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />
      <div>
        {location?.state?.state === 'Order' ||
        location?.search?.includes('Order') ? (
          <ReturnOrderPage
            canEdit={canEdit}
            doneEdit={() => setCanEdit(false)}
            commentId={commentAllId}/>
        ) : null}
        {location?.state?.state === 'Import' ||
        location?.search?.includes('Import') ? (
          <ReturnImportPage
            canEdit={canEdit}
            doneEdit={() => setCanEdit(false)}
            commentId={commentAllId}/>
        ) : null}
        {location?.state?.state === 'Stock' ||
        location?.search?.includes('Stock') ? (
          <ReturnStockPage
            canEdit={canEdit}
            doneEdit={() => setCanEdit(false)}
            commentId={commentAllId}/>
        ) : null}
        {!canEdit && (
          <CommentTabsComponent
            style={{ backgroundColor: 'white', margin: '20px', marginTop: 0 }}
            onSend={onSendComment}
            tabs={tabs}
            commentList={commentList!}
            refectComments={getCommentList}
            itemId={parseInt(id)}
            updateItem={(commentId: number) => {
              setCommentAllId(commentId);
              setCanEdit(true);
            }}
            commentGroup={CommentGroup.RETURN_DETAIL}
          />
        )}
      </div>
    </>
  );
}

export default ReturnPageDetail;
